import {
  Flex,
} from '@chakra-ui/react';
import RaceMinimapMarkers from '../RaceMinimapMarkers';
import { RModal } from 'components';
import { IconBraking, IconFastTurns, IconInfinityGradient, IconSlowTurns, IconSpeedStats, IconThrottle } from 'icons';
import MetricsTag from 'components/Tags/MetricsTag';

interface RaceThumbnailModalProps {
  title: string;
  isOpen: boolean;
  difficulty: number;
  tier: 'race' | 'tournament';
  onClose: () => void;
}

const metrics = [
  {
    backgroundColor: 'linear-gradient(90.65deg, rgba(255, 82, 82, 0) 0.56%, rgba(255, 82, 82, 0.24) 99.44%)',
    borderColor: 'linear-gradient(90.65deg, rgba(255, 82, 82, 0) 0.56%, rgba(255, 82, 82, 0.24) 99.44%)',
    icon: <IconSpeedStats 
      __css={{
        path: {
          fill: 'rgba(255, 82, 82, 1)',
        }
      }}
    />,
    color: 'rgba(255, 82, 82, 1)',
    text: 'Speed',
  },
  {
    backgroundColor: 'linear-gradient(90.65deg, rgba(255, 193, 7, 0) 0.56%, rgba(255, 193, 7, 0.24) 99.44%)',
    borderColor: 'linear-gradient(90.65deg, rgba(255, 193, 7, 0) 0.56%, rgba(255, 193, 7, 0.24) 99.44%)',
    icon: <IconBraking 
      __css={{
        path: {
          fill: 'rgba(255, 193, 7, 1)',
        }
      }}
    />,
    color: 'rgba(255, 193, 7, 1)',
    text: 'Braking',
  },
  {
    backgroundColor: 'linear-gradient(90.65deg, rgba(189, 189, 189, 0) 0.56%, rgba(189, 189, 189, 0.24) 99.44%)',
    borderColor: 'linear-gradient(90.65deg, rgba(189, 189, 189, 0) 0.56%, rgba(189, 189, 189, 0.24) 99.44%)',
    icon: <IconThrottle 
      __css={{
        path: {
          fill: 'rgba(204, 204, 204, 1)',
        }
      }}
    />,
    color: 'rgba(204, 204, 204, 1)',
    text: 'Acceleration',
  },
  {
    backgroundColor: 'linear-gradient(90.65deg, rgba(0, 255, 43, 0) 0.56%, rgba(0, 255, 43, 0.24) 99.44%)',
    borderColor: 'linear-gradient(90.65deg, rgba(0, 255, 43, 0) 0.56%, rgba(0, 255, 43, 0.24) 99.44%)',
    icon: <IconSlowTurns 
      __css={{
        path: {
          fill: 'rgba(0, 255, 43, 1)',
        }
      }}
    />,
    color: 'rgba(0, 255, 43, 1)',
    text: 'Slow Turns',
  },
  {
    backgroundColor: 'linear-gradient(90.65deg, rgba(0, 255, 232, 0) 0.56%, rgba(0, 255, 232, 0.24) 99.44%)',
    borderColor: 'linear-gradient(90.65deg, rgba(0, 255, 232, 0) 0.56%, rgba(0, 255, 232, 0.24) 99.44%)',
    icon: <IconFastTurns 
      __css={{
        path: {
          fill: 'rgba(0, 255, 232, 1)', 
        }
      }}
    />,
    color: 'rgba(0, 255, 232, 1)',
    text: 'Fast Turns',
  }
]

const RaceThumbnailModal = ({
  title,
  difficulty,
  isOpen,
  onClose,
  tier,
}: RaceThumbnailModalProps) => {
  return (
    <RModal
      isOpen={isOpen} 
      onClose={onClose}
      size="2xl"
      isCentered
      title="Track Preview"
      icon={<IconInfinityGradient />}
    >
      <Flex
        gap="2"
        alignItems="center"
        wrap="wrap"
      >
        {metrics.map((metric) => (
          <MetricsTag
            key={metric.text}
            {...metric}
          />
        ))}
      </Flex>
      <Flex
        background="linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%)"
        alignItems="center"
        justifyContent="center"
        position="relative"
        borderRadius="8px"
        w="full"
        h="full"
        p="4"
        _before={{
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: '8px',
          background: 'linear-gradient(90deg, rgba(79, 197, 186, 0.6) 0%, rgba(79, 197, 186, 0.12) 100%)',
          padding: '2px',
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
        }}
      >
        <RaceMinimapMarkers race={title} width="65%" height="100%" opacity={1} />
      </Flex>
    </RModal>
  );
};

export default RaceThumbnailModal;
